import { Security } from '../../pages';

export const routingSecurity = [
  {
    path: '/security/confirm',
    exact: true,
    component: Security,
    claims: ['CanSeeCheckOutTimeSection'],
  },
];
